/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * TYPE : the auth support type
 *   * VALUE : the auth support value
 *   * STATE : the auth support state
 *   * CREATION_DATE : the auth support creation date
 *   * VALIDITY_START
 *   * VALIDITY_END
 *   * SUBSERVICE_NAME
 *   * SUBSCRIPTION_NAME
 */
export enum AuthSupportSortFieldName {
  TYPE = 'TYPE',
  VALUE = 'VALUE',
  STATE = 'STATE',
  CREATION_DATE = 'CREATION_DATE',
  VALIDITY_START = 'VALIDITY_START',
  VALIDITY_END = 'VALIDITY_END',
  SUBSERVICE_NAME = 'SUBSERVICE_NAME',
  SUBSCRIPTION_NAME = 'SUBSCRIPTION_NAME'
}
